import { render, staticRenderFns } from "./LeaveRecordsList.vue?vue&type=template&id=38a2896e&scoped=true&"
import script from "./LeaveRecordsList.vue?vue&type=script&lang=js&"
export * from "./LeaveRecordsList.vue?vue&type=script&lang=js&"
import style0 from "./LeaveRecordsList.vue?vue&type=style&index=0&id=38a2896e&lang=scss&scoped=true&"
import style1 from "./LeaveRecordsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a2896e",
  null
  
)

export default component.exports